import { type ReactElement } from 'react'
import { Box, Typography, Card, CardHeader, CardContent, Divider, Grid } from '@mui/material'
import QRCode from '@/components/common/QRCode'
import useSafeAddress from '@/hooks/useSafeAddress'
import { useCurrentChain } from '@/hooks/useChains'
import { useAppSelector } from '@/store'
import { selectSettings } from '@/store/settingsSlice'
import useDesktop from '@/hooks/useDesktop'
import EthHashInfo from '@/components/common/EthHashInfo'

const ScanQrCode = (): ReactElement => {
  const isDesktop = useDesktop()
  const safeAddress = useSafeAddress()
  const chain = useCurrentChain()
  const settings = useAppSelector(selectSettings)
  const qrPrefix = settings.shortName.qr ? `${chain?.shortName}:` : ''

  const qrCode = `${safeAddress}`

  return (
    <Card sx={{ marginX: isDesktop ? '0px' : '0px' }}>
      <CardHeader
        sx={{ paddingY: '8px' }}
        title={
          <Typography
            textAlign="center"
            sx={{
              fontSize: '14px',
              lineHeight: '160%',
              fontWeight: '400',
            }}
          >
            Your Inherit address on <span style={{ color: 'var(--Blue-Ribbon-600, #5D5DFF)' }}>{chain?.chainName}</span>
          </Typography>
        }
      />
      <Divider flexItem sx={{}} />
      <CardContent sx={{ padding: '16px' }}>
        <Box display="flex" flexDirection="row" justifyContent="center" alignItems="center">
          <QRCode value={qrCode} size={150} />
        </Box>
        <Grid
          container
          flexDirection="row"
          justifyContent="center"
          alignItems="center"
          sx={{
            backgroundColor: 'var(--Ebony-Clay-950, #2F354B)',
            borderRadius: '4px',
            marginTop: '16px',
            padding: '8px',
          }}
        >
          <EthHashInfo
            address={safeAddress}
            showName={false}
            shortAddress={false}
            showAvatar={false}
            shortenLen={10}
            prefix={undefined}
            hasExplorer
            showCopyButton
          />
        </Grid>
        <Grid
          container
          mt="16px"
          sx={{
            borderRadius: '4px',
            border: '1px solid var(--Ebony-Clay-950, #2F354B)',
          }}
          p="8px 16px"
          pl={'8px'}
        >
          <Grid item xs={1} textAlign="center" sx={{ paddingTop: '2px' }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path
                d="M8.00016 1.33325C4.32016 1.33325 1.3335 4.31992 1.3335 7.99992C1.3335 11.6799 4.32016 14.6666 8.00016 14.6666C11.6802 14.6666 14.6668 11.6799 14.6668 7.99992C14.6668 4.31992 11.6802 1.33325 8.00016 1.33325ZM8.00016 8.66659C7.6335 8.66659 7.3335 8.36659 7.3335 7.99992V5.33325C7.3335 4.96659 7.6335 4.66659 8.00016 4.66659C8.36683 4.66659 8.66683 4.96659 8.66683 5.33325V7.99992C8.66683 8.36659 8.36683 8.66659 8.00016 8.66659ZM8.66683 11.3333H7.3335V9.99992H8.66683V11.3333Z"
                fill="#FC8313"
              />
            </svg>
          </Grid>
          <Grid item xs={11}>
            <Typography
              sx={{
                fontSize: '14px',
                lineHeight: '160%',
                fontWeight: '400',
              }}
            >
              Only send {chain?.nativeCurrency.symbol} and tokens (ERC-20, ERC-721) on{' '}
              <span style={{ color: 'var(--Blue-Ribbon-600, #5D5DFF)' }}>{chain?.chainName}</span> to this address.
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

export default ScanQrCode
